export default {
    AWS_LAMBDA_GETSIGNEDURL_ENDPOINT: '/your-lambda-endpoint-goes-here'
  }
  


// WEBPACK FOOTER //
// ./src/component/ccpay/config.js